import axios from 'axios';
import { getInstance } from '../auth/authWrapper';

export async function listDigiscorePartners() {
  const authService = getInstance();
  const token = await authService.waitForToken();

  return axios.get(`${process.env.VUE_APP_DIGISCORE_API}/digiscorePartners`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export default {};
